import {getConnection} from '../../../_shared/GWTBridge/invoke/procMain';
import {buildServerCall} from '../../../services/wcfService';

export function procNewReport(
    type: string,
    ename: string,
    debug: boolean,
    mode: string,
    format: string,
    zoomvalue: string,
    pdf: boolean
) {
    const methodName = 'ProcNewReport';
    const reason = 'ProcNewReportReact';
    const parameters = {
        type: [type],
        ename: [ename],
        debug: [debug.toString()],
        mode: [mode],
        format: [format],
        zoomvalue: [zoomvalue],
        pdf: [pdf ? '1' : '0']
    };
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}
